import React, { useEffect, useState } from 'react';
import { trackGtm } from '../../helpers/event-tracking';
import { EVENTS_ANALYTICS } from '../../consts/event.consts';
import bemCn from 'bem-cn';
import loadable from '@loadable/component';
import { AUTH_TESTS } from '../listings/auth-test.const';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import { getCityFaqs } from '../../consts/city-faqs.consts';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { escapeString } from '../../helpers/escape-string';
import { NEARBY_STATES } from '../../consts/states';
import { RouteFormatter } from '../../routes';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { RenderTopCities, RenderTopCitiesCanada, RenderTopState } from '../../components/seo-listings/top-list';
import SeoCitySingleHeader from '../../components/seo-listings/header';
import SpotBreadcrumbs from '../../components/spot-breadcrumbs';
import RenderHowWorks from '../../components/seo-listings/how-works';
import EmptySpotsSSR from '../../components/empty/empty-spots-ssr';
import RenderWhyRent from '../../components/seo-listings/why-rent';
import ToogleButton from '../../components/toogle-button';
import SpotDetails from '../../components/seo-listings/spot-details';
import { SpotsResult } from '../../components/sort-spots';
import RenderAbout from '../../components/seo-listings/about';
import SniffAsSeen from '../../components/sniif-as-seen';
import SniffButton from '../../components/sniff-button';
import SharePage from '../../components/spot-share-button/share-page';
import FooterNew from '../../components/footer-new';
import SeoFaqs from '../../components/seo-listings/faqs';
import SvgAmenitiesKiddiePool from 'src/assets/svg/amenities/kiddie-pool.svg';
import SvgAmenitiesIndoor from 'src/assets/svg/amenities/indoor.svg';
import SvgAmenitiesTrail from 'src/assets/svg/amenities/trail.svg';
import SvgTopBadgeColor from 'src/assets/svg/SvgTopBadgeColor.svg';
import SvgChevronRight from 'src/assets/svg/SvgChevronRight.svg';
import SvgFilterNew from 'src/assets/svg/SvgFilterNew.svg';
import SvgSearch from 'src/assets/svg/SvgSearch.svg';
import SvgFenced from 'src/assets/svg/SvgFenced.svg';
import SvgDogPaw from 'src/assets/svg/SvgDogPaw.svg';
import SvgChTree from 'src/assets/svg/SvgChTree.svg';
import SvgRuler from 'src/assets/svg/SvgRuler.svg';
import SvgShare from 'src/assets/svg/SvgShare.svg';
import SvgDog from 'src/assets/svg/SvgDog.svg';
import SvgPin from 'src/assets/svg/SvgPin.svg';
import './index.scss';

const CookieService = require('../../services/cookie.service');
const useGetSpotPhotosPaginated = require('../../services/hooks/useGetSpotPhotosPaginated');

const SniffAppleMaps = loadable(() => import('../../components/sniff-apple-maps/city'));
const BlurSignupModal = loadable(() => import('../../components/modal-blur-signup'));

const b = bemCn('seo-state-single');

const subSeoDesc =
    "Sniffspot's private dog parks are the best way to exercise your dog. We have the best variety and the best priced dog parks anywhere!";

const LISTING_DEFAULT_MAP_ZM = 25000; // in meters

const toggleFiltersBtn = [
    {
        id: 'PUBLIC_PARK',
        text: 'Public park',
        svg: <SvgChTree />,
        isOn: true,
        auth: AUTH_TESTS.TOGGLE_PUBL_SPOT,
    },
    {
        id: 'PRIVATE_PARK',
        text: 'Private park',
        svg: <SvgDogPaw />,
        isOn: true,
        auth: AUTH_TESTS.TOGGLE_PRIV_SPOT,
    },
    {
        id: 'FULLY_FENCED',
        text: 'Fully fenced',
        svg: <SvgFenced />,
        auth: AUTH_TESTS.TOGGLE_FENCED,
    },
    {
        id: 'WATER_PARKS',
        text: 'Water parks',
        svg: <SvgAmenitiesKiddiePool />,
        auth: AUTH_TESTS.TOGGLE_WATER,
    },
    {
        id: 'NO_DOGS',
        text: 'Fewer dogs seen/heard',
        svg: <SvgDog />,
        auth: AUTH_TESTS.TOGGLE_NODOGS,
    },
    {
        id: '10_MILES',
        text: '< 10 miles away',
        svg: <SvgPin />,
        auth: AUTH_TESTS.TOGGLE_IN10MILES,
    },
    {
        id: 'BIG_AREA',
        text: '0.5+ acres',
        svg: <SvgRuler />,
        auth: AUTH_TESTS.TOGGLE_MINHALFACR,
    },
    {
        id: 'TOP_SPOT',
        text: 'Top spots',
        svg: <SvgTopBadgeColor />,
        auth: AUTH_TESTS.TOGGLE_TOPSPOTS,
    },
    {
        id: 'HIKING',
        text: 'Hiking trails',
        svg: <SvgAmenitiesTrail />,
        auth: AUTH_TESTS.TOGGLE_HIKING,
    },
    {
        id: 'INDOOR',
        text: 'Indoor play space',
        svg: <SvgAmenitiesIndoor />,
        auth: AUTH_TESTS.TOGGLE_INDOOR,
    },
    {
        id: 'FILTER',
        text: 'More...',
        svg: <SvgFilterNew />,
        auth: AUTH_TESTS.TOGGLE_FILTERS,
    },
];

const TriggerComp = () => (
    <ToogleButton className={b('filter-toggle_button')} activeCssClass="active" style={{ padding: '6px 16px' }} svg={<SvgShare className="me-0" />} />
);

const RenderFilters = ({ getAuthTest, goToSearchPage, mobile }) => {
    const [shareModal, setShareModal] = useState(false);

    const toggleShareModal = () => setShareModal((s) => !s);

    return (
        <div className={b('filter-toggle').mix(mobile ? 'd-md-none' : '')}>
            <SharePage {...{ title: 'Share this page!', TriggerComp, shareModal, toggleShareModal }} />
            {toggleFiltersBtn.map((v) => (
                <ToogleButton
                    key={v.id}
                    className={b('filter-toggle_button')}
                    svg={v.svg}
                    name={v.text}
                    toogleOn={v.isOn}
                    onClick={v.auth ? () => getAuthTest(v.auth) : goToSearchPage}
                />
            ))}
        </div>
    );
};

const NearbyState = ({ s }) => {
    const href = RouteFormatter.listings({ first: escapeString(s) });

    return (
        <a href={href} className="nearby-state">
            <SvgPin className="me-2" />
            <span className="snif-p snif-medium">{s}</span>
            <SvgChevronRight className="d-md-none chev-r" />
        </a>
    );
};

const SeoNearby = ({ isMobile, hasNearby, nearbyStates }) => {
    if (!hasNearby) {
        return '';
    }

    return (
        <div className={b('container')}>
            <h2 className="snif-m2 snif-l2-pc snif-semibold mb-2 mb-md-3">Nearby states to rent a private dog park</h2>
            <div className="d-md-flex">
                {nearbyStates.map((s, i) => (
                    <NearbyState key={i} {...{ isMobile, s }} />
                ))}
            </div>
        </div>
    );
};

const StateSingle = ({ state, serverSSR }) => {
    const isMobile = useMobileScreen();
    const [showMap, setShowMap] = useState(false);
    const [isMapView, setisMapView] = useState(false);
    const [isBlurTest, setIsBlurTest] = useState(null);
    const [activeSpotId, setActiveSpotId] = useState(null);
    const { getSpotPhotosPaged } = serverSSR ? {} : useGetSpotPhotosPaginated.default();

    const nearbyStates = NEARBY_STATES[state?.stateUrl]?.sort() || [];
    const hasNearby = nearbyStates && !!nearbyStates.length;
    const title = `Rent a private dog park in ${state?.name}`;
    const resultText = `${state.totalSpots} spot${state.totalSpots > 1 ? 's' : ''} found`;
    const pages = Math.ceil(state.totalSpots / 30);
    const showText = `Showing 1 - ${state.spots.length} of ${state.totalSpots > 100 ? '100+' : state.totalSpots} spots`;
    const faqs =
        state?.faqs?.length > 0
            ? state.faqs.map((c) => ({
                  que: c.question,
                  ans: () => <p dangerouslySetInnerHTML={{ __html: c.answer }} />,
              }))
            : getCityFaqs(state);

    const listBread = [
        {
            name: 'All dog parks',
            url: RouteFormatter.listings({}),
        },
        {
            name: state?.name || '',
        },
    ];

    const toggleMapView = () => setisMapView((m) => !m);

    const goToSearchPage = (page) => {
        window.location = RouteFormatter.listings({}, { query: { loc: state?.name, page: page == 1 ? undefined : page } });
    };

    const getAuthTest = async (test) => {
        const re = `${window.location.pathname}#${test}`;
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
        CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.FILTERS_WEB, { expires: 1 });
        setIsBlurTest('v2');
        return true;
    };

    const filtersClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        getAuthTest(AUTH_TESTS.TOGGLE_FILTERS);
    };

    const onSortChange = () => getAuthTest(AUTH_TESTS.TOGGLE_SORT_DISTANCE);

    useEffect(() => {
        setShowMap(isMapView);
    }, [isMapView]);

    useEffect(() => {
        trackGtm({ action: EVENTS_ANALYTICS.screen_search, props: { event_category: 'View_front' } });

        if (!isMobile) {
            setShowMap(true);
        }
    }, []);

    return (
        <>
            <SeoCitySingleHeader {...{ state, isMapView, getAuthTest, toggleMapView }} />
            <RenderFilters {...{ getAuthTest, goToSearchPage }} mobile />
            <div className={b()}>
                <div className={b('main')}>
                    <div className={b('main-maps', { showMap })}>
                        <div className="d-none d-md-block">
                            <SpotBreadcrumbs {...{ listBread }} />
                            <div className="search-bar-closed" onClick={() => getAuthTest(AUTH_TESTS.TOGGLE_SEARCH)}>
                                <SvgSearch width={20} height={20} />
                                <div className="search-bar-closed_text-container">
                                    <div className="snif-s1">{state.name}</div>
                                    <div className="d-none d-md-block mx-1">/</div>
                                    <div className="snif-s2 snif-s1-pc">
                                        <span>Any date</span>•<span>Any time</span>
                                    </div>
                                </div>
                                <SniffButton className="filter-button" color="secondary" size="sm" onClick={filtersClick}>
                                    <SvgFilterNew width={20} height={20} />
                                    <div className="green-dot">1</div>
                                </SniffButton>
                            </div>
                        </div>
                        <div className={b('main-maps-content')}>
                            {showMap && (
                                <SniffAppleMaps
                                    center={{ latitude: parseFloat(state.latitude), longitude: parseFloat(state.longitude) }}
                                    spots={state.spots}
                                    cameraDistance={LISTING_DEFAULT_MAP_ZM}
                                    activeSpotId={activeSpotId}
                                    {...{ setMapRect: () => {}, setMapCenter: () => {}, onGetSpotsList: () => {} }}
                                />
                            )}
                        </div>
                    </div>
                    <div className={b('main-content')}>
                        <div className="d-md-none">
                            <SpotBreadcrumbs {...{ listBread }} />
                            <div className="px-2">
                                <h2 className="snif-m1 snif-semibold text-dark mt-2 mb-1">{title}</h2>
                                <p className="snif-s1 snif-regular text-dark mb-3">{subSeoDesc}</p>
                                <SpotsResult mobile className="mb-3" {...{ resultText, onSortChange }} />
                            </div>
                        </div>
                        <div className="d-none d-md-block position-relative my-3 ms-1">
                            <div className={b('main-content-desktop-header')}>
                                <h1 className="snif-l1 snif-semibold text-dark">{title}</h1>
                            </div>
                            <RenderFilters {...{ getAuthTest, goToSearchPage }} />
                            <p className="snif-p snif-regular text-dark mt-3 mb-1">{subSeoDesc}</p>
                            <SpotsResult className="mt-3" {...{ resultText, onSortChange }} />
                        </div>
                        <div className={b('listings')}>
                            {state.spots.length ? (
                                state.spots.map((spot, idx) => {
                                    const first = idx === 0;
                                    return (
                                        <SpotDetails
                                            key={spot.id}
                                            onMouseEnter={() => setActiveSpotId(spot.id)}
                                            onMouseLeave={() => setActiveSpotId(null)}
                                            {...{ spot, first, getSpotPhotosPaged }}
                                        />
                                    );
                                })
                            ) : (
                                <EmptySpotsSSR />
                            )}
                        </div>
                        <div className={b('listings_footer')}>
                            <p className="d-none d-md-block snif-p snif-medium text-medium">{showText}</p>
                            <div className={b('pagination')}>
                                {[...Array(pages)].slice(0, 5).map((_, i) => (
                                    <span key={i} className={b('pagination_number', { active: i == 0 })} onClick={() => goToSearchPage(i + 1)}>
                                        {i + 1}
                                    </span>
                                ))}
                                {pages > 1 && (
                                    <span className={b('pagination_right')} onClick={() => goToSearchPage(2)}>
                                        <SvgChevronRight />
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="l-container">
                    <SniffAsSeen isMobileSSR={isMobile} useState={useState} />
                </div>
                <RenderWhyRent data={state} />
                <RenderHowWorks {...{ isMobile, name: state?.name }} />
                <div className={b('nearby')}>
                    <SeoNearby {...{ isMobile, hasNearby, nearbyStates }} />
                </div>
                <SeoFaqs {...{ faqs, state }} />
                <RenderAbout />
                <RenderTopCities SSR {...{ isMobile }} />
                <RenderTopState SSR {...{ isMobile }} />
                <RenderTopCitiesCanada SSR {...{ isMobile }} />
            </div>
            <FooterNew {...{ isShowCities: false, isHome: true }} />
            <BlurSignupModal
                {...{
                    isBlurTest,
                    setIsBlurTest,
                    isMobile,
                    useStateSSR: useState,
                }}
            />
        </>
    );
};

export default StateSingle;
